import React from "react";
import Framework from "@beardeddevops/react.framework";
import Types from "constants/Types";
import PropTypes from "prop-types";
import {Collections, Parts} from "components";
import moment from "moment-timezone";
import {Button} from "reactstrap";
import API from "@beardeddevops/react.api";

/**
 *  @property {Customers_Locations_Object} state
 *  @property {object} model
 *  @property {Customers_Locations_Properties} model.properties
 *  @property {Customers_Locations_Is} model.is
 *  @property {Customers_Locations_Has} model.has
 */
export default class CustomerLocation extends Framework.Components.Object {
	static propTypes = {
		...super.PropTypes,
		location: PropTypes.object,

	};

	constructor(props) {
		super(props, Types.Customers_Locations._name);
		this.redirect = this.props.baseUrl;
		this.state.customer = this.props.customer
		this.state.parent = this.props.parent
		this.state.condense = this.props.condense;
	}

	//https://stackoverflow.com/a/58869663
	// When tab is pressed, set the focused state to the next element ID provided in each input
	handleKeyUp(e) {

		e.which = e.which || e.keyCode;

		// If the key press is Enter
		if (e.which === 'Tab') {
			switch (e.target.id) {
				case "input-one":
					two.current.focus();
					break;
				case "input-two":
					three.current.focus();
					break;
				case "input-three":
					one.current.focus();
					break;

				default:
					break;
			}
		}
	}

	componentDidUpdate(prevProps, prevState, snapshot) {
		super.componentDidUpdate(prevProps, prevState, snapshot);
		if (prevState.region !== this.state.region && typeof this.props.regionChange === 'function') {
			this.props.regionChange(this.state.regions.name, this.state.region);
		}
		if (prevState.region !== this.state.region && typeof this.props.updateRegion === 'function' && prevState.region) {
			this.props.updateRegion(this.state.region, this.state.regions.name);
		}
		if ((prevState.latitude !== this.state.latitude || prevState.longitude !== this.state.longitude) && typeof this.props.updateGivenAddress === 'function') {
			this.props.updateGivenAddress(this.state.latitude, this.state.longitude);
		}
		if (prevProps.id !== this.props.id) {
			this.state.validateAddress = 'validated';
		}
	}

	componentDidMount() {
		super.componentDidMount();
		if (this.state.pkey) {
			this.state.validateAddress = 'validated';
		}
		if (this.props.address) {
			this.setState({
				city: this.props.address.city,
				state: this.props.address.state,
				street_1: this.props.address.street_1,
				zip: this.props.address.zip,
				region: this.props.address.region,
				latitude: this.props.address?.latitude,
				longitude: this.props.address?.longitude,
			})
		}

	}

	async handleSubmit(event, suppressToast = false, suppressProcess = false) {
		if (!this.state.pkey && typeof(this.props.ref) !== 'undefined') return; //if it's an empty location inside a customer, so it doesn't save twice
		if (!this.state.latitude || !this.state.longitude) {
			await this.setState({validateAddress: this.state.street_1 + ", " + this.state.city + " " + this.state.state})
		}
		//timeout is to assure that the address is validated
		setTimeout(async () => {
			if (this.state.validateAddress === 'validated') {
				await super.handleSubmit(event, suppressToast, suppressProcess).then();
			} else if (!this.state.street_1){
				API.Toast.info('Unable to validate the address, please double check that everything is correct.', {
					position: API.Toast.POSITION.TOP_CENTER
				});
			} else {
				API.Toast.info('Unable to validate the address, please double check that everything is correct.', {
					position: API.Toast.POSITION.TOP_CENTER
				});
			}
		}, 500)
	}

	findClosetFE = () => {
		let Address = {
			street_1: this.state.street_1,
			city: this.state.city,
			state: this.state.state,
			zip: this.state.zip,
			latitude: this.state.latitude,
			longitude: this.state.longitude,
			region: this.state.region,
		}
		localStorage.setItem('findFEAddress', JSON.stringify(Address))
		window.open('/dispatch/closest')
	}

	form = () => {

		let {properties} = this.model;
		//TODO: fix this
		let {
			loading,
			loaded,
			region,
			region_error,
			regions,
		} = this.state;
		let {display} = this.props;
		let grammar = this.state.modified ? `Modified By ${this.state.users_related_by_modifier} on ${moment(this.state.modified).format('MM/DD/YY')} at ${moment(this.state.modified).format('h:mm a')}` :
			this.state.creator ? `Created By ${this.state.users_related_by_creator} on ${moment(this.state.created).format('MM/DD/YY')} at ${moment(this.state.created).format('h:mm a')}` : null;


		return (
			<div>
				<fieldset>
					<div className={'section-title'}>
						<h4 className="section-title">Address</h4>
						<div className={'flex-end text-right'}>
							<div className={'row'}>
								<div className={'col-auto'} style={{paddingRight: '1px'}}>
									{this.props.findFE &&
										<Button size="sm" block={true} onClick={() => {
											this.findClosetFE()
										}} color="primary">
											Find Closest FE
										</Button>}
								</div>
								<div className={'col-auto'} style={{paddingLeft: '1px'}}>
									{this.props.condense &&
										<Button color="green-meadow" size={"sm"} block={true} onClick={() => {
											this.setState({condense: !this.state.condense})
										}}>Edit Address</Button>}
								</div>
							</div>
						</div>
					</div>
					<Parts.Address findFE={this.props.findFE} history={this.props.history} object={{...this.state}} properties={properties}
					               parent={this} validateAddress={this.state.validateAddress} condense={this.state.condense} searchChange={this.props.searchChange} customerAddress={this.props.addressToBeValidated}/>

					{!this.state.condense && <div className="form-group" data-cy="customer-region">
						<Framework.Elements.Select
							shouldLoad={loaded}
							property={properties.region}
							value={region}
							error={region_error}
							object={regions}
							update={this.handleSelectPropertyUpdate}
							nullable={false}
						/>
					</div>}
					{(grammar && display) && <Button data-id="address-log"
					                                 onClick={this.toggle('modalAddressLog')}
					                                 size="sm"
					                                 color="grey">
						<i className="fa fa-user"/>&nbsp;&nbsp;{grammar}
					</Button>}

					<Framework.Elements.UniversalModal
						name={"Change Logs"}
						history={this.props.history}
						object={Collections.LogsCustomersLocations}
						toggle={this.state.modalAddressLog}
						reportClose={this.reportClose('modalAddressLog')}
						hideGoTo={true}
						hasSubmit={false}
						size={'xl'}
						objectProps={{parent: this.state.pkey?.toString(), grandparent: this.state.parent?.toString()}}
					/>
				</fieldset>

				<Framework.Elements.LoadingSpinner isLoading={loading}/>
			</div>
		)
	};

}
